interface ICalculatePageCount {
  limit: number;
  totalItems?: number;
}

export const calculatePageCount = ({
  limit,
  totalItems,
}: ICalculatePageCount) => (totalItems ? Math.ceil(totalItems / limit) : 0);
